import * as React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Homepage from './pages/Homepage'
import ScrollTop from "./utility/ScrollTop";

import Header from "./components/header";
import Footer from "./components/Footer";
import './App.css';
import "@material-tailwind/react/tailwind.css"

function App(): JSX.Element {
  return (
    <div>
      <Header/>
        <ScrollTop/>
        <Switch>
        <Route exact path="/" component={Homepage} />
        <Route path="*" component={()=>{return <Redirect to="/" />}}/>
        </Switch>
      <Footer/>
    </div>
  );
}

export default App;
